export const SUBSCRIPTION_PRICE_PER_MONTH_RUB = 3_000;
export const SUBSCRIPTION_PRICE_PER_MONTH_EUR = 30;
export const SUBSCRIPTION_DURATION_DAYS = 30;
